'use client';

import { useEffect, useState } from 'react';
import { getUA } from 'react-device-detect';

export const IsBot = () => {
  const [isBot, setIsBot] = useState(false);
  const userAgent = getUA;

  useEffect(() => {
    setIsBot(
      userAgent.includes('+http://yandex.com/bots') ||
        userAgent.includes('+http://www.google.com/bot') ||
        userAgent.toLowerCase().includes('bot'),
    );
  }, [userAgent]);

  return isBot;
};
